import React, { PureComponent } from 'react';

import Modal from '../Modal/Modal.component';
import Button from '../Button/Button.component';

import iconClose from '../FormBuilder/assets/close.svg';

import config from './ModalInput.config';
import './ModalInput.less';

class ModalInput extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isFocus: false,
      touched: false,
      value: '',
    };
  }

  static getDerivedStateFromProps(prevProps, prevState) {
    const { value, touched } = prevState;
    const { defaultValue } = prevProps;

    if (value === '' && !touched && defaultValue) {
      return {
        value: defaultValue,
        touched: true,
      };
    }
    return null;
  }

  _onChange = event => {
    const inputValue = event.target.value.replace(/[^a-zA-Z ]/g, '');

    this.setState({
      value: inputValue,
    });
  };

  _onDismiss = () => {
    document.getElementById('input_modalInput').blur();
    this.setState({ isFocus: false, value: '' });
  };

  _onFocus = () => {
    this.setState({ isFocus: true });
  };

  _onBlur = () => {
    this.setState({ isFocus: false });
    document.body.scrollTop = 0;
  };

  _isEmpty = () => this.state.value.trim().length === 0;

  _renderInputLayout = () => {
    const { isFocus, value } = this.state;
    const { placeholder } = this.props;

    const inputState = isFocus && 'active';

    return (
      <div className="AlphanumericCustomerNumber">
        <div className="input-row">
          <div className={`input-box ${inputState}`}>
            <input
              id="input_modalInput"
              type="text"
              autoComplete="off"
              value={value}
              placeholder={placeholder}
              onFocus={this._onFocus}
              onBlur={this._onBlur}
              onChange={this._onChange}
              maxLength="50"
            />
            <button
              type="button"
              id="btn_closeCustomerNumber"
              className={`icon-status ${
                isFocus && value.length >= 1 ? 'show' : ''
              }`}
              onMouseDown={this._onDismiss}
            >
              <img src={iconClose} alt="close" />
            </button>
          </div>
        </div>
      </div>
    );
  };

  _renderButton = () => {
    const { value } = this.state;
    const { onClickSubmit, btnLabel } = this.props;
    const buttonClass = this._isEmpty() ? 'primary inactive' : 'primary';

    return (
      <Button
        id="btn_modalInput"
        addClass={buttonClass}
        action={() => onClickSubmit(value)}
      >
        {btnLabel}
      </Button>
    );
  };

  render() {
    const { visible, onClose, title } = this.props;

    return (
      <div id="modal-input">
        <Modal visible={visible} onClose={onClose}>
          <h1 className="title-text" id="text_titleModalInput">
            {title}
          </h1>
          {this._renderInputLayout()}
          {this._renderButton()}
        </Modal>
      </div>
    );
  }
}

ModalInput.displayName = config.displayName;
ModalInput.defaultProps = config.defaultProps;
ModalInput.propTypes = config.propTypes;

export default ModalInput;
